import { z } from 'zod';
import { booleanOperators, datetimeOperators, picklistOperators } from './operators';

export const datetimeFilter = z
  .object({
    value: z
      .union([z.string(), z.array(z.string())])
      .nullable()
      .optional(),
    operator: datetimeOperators,
  })
  .optional();

export const picklistFilter = z
  .object({
    value: z
      .union([z.number(), z.array(z.number())])
      .nullable()
      .optional(),
    operator: picklistOperators,
  })
  .optional();

export const booleanFilter = z
  .object({
    value: z.boolean().nullable().optional(),
    operator: booleanOperators,
  })
  .optional();
